import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";
import img1 from "../schoolgirl.jpg";
const CSS_Float = () => {
  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">🌊 CSS Float</h1>

      <p className="tutorial-intro">
        The <code>float</code> property in CSS is used to place an element to
        the left or right of its container, allowing text and inline elements to
        wrap around it.
      </p>

      {/* Why Use Float */}
      <div
        style={{
          background: "linear-gradient(135deg, #fef3c7, #fcd34d)",
          padding: "1rem",
          borderRadius: "12px",
          marginBottom: "2rem",
          textAlign: "center",
        }}
      >
        <h2 style={{ color: "#92400e", marginBottom: "0.5rem" }}>
          🌟 Why Use CSS Float?
        </h2>
        <p style={{ fontSize: "1.1rem", lineHeight: "1.6" }}>
          Floats were originally designed for wrapping text around images.
          Today, they’re often replaced by Flexbox or Grid, but floats are still
          useful for specific layouts and legacy designs.
        </p>
      </div>

      {/* Float Left */}
      <div className="tutorial-section">
        <h2 className="section-title">1️⃣ float: left</h2>
        <p>
          Moves the element to the left side of its container. Other content
          will wrap around it.
        </p>

        <CodeCopyBlock
          code={`.box {
  float: left;
  width: 150px;
  height: 100px;
  background-color: #60a5fa;
  margin: 10px;
}`}
        />

        <div style={{ border: "2px dashed #60a5fa", padding: "10px" }}>
          <div
            style={{
              float: "left",
              width: "150px",
              height: "100px",
              backgroundColor: "#60a5fa",
              margin: "10px",
              borderRadius: "6px",
            }}
          ></div>
          This text will wrap around the floated box. Notice how it flows to the
          right side of the blue box.
        </div>
      </div>

      {/* Float Right */}
      <div className="tutorial-section">
        <h2 className="section-title">2️⃣ float: right</h2>
        <p>
          Moves the element to the right side of its container. Other content
          will wrap around it.
        </p>

        <CodeCopyBlock
          code={`.box {
  float: right;
  width: 150px;
  height: 100px;
  background-color: #f472b6;
  margin: 10px;
}`}
        />

        <div style={{ border: "2px dashed #f472b6", padding: "10px" }}>
          <div
            style={{
              float: "right",
              width: "150px",
              height: "100px",
              backgroundColor: "#f472b6",
              margin: "10px",
              borderRadius: "6px",
            }}
          ></div>
          This text will wrap around the floated box. Notice how it flows to the
          left side of the pink box.
        </div>
      </div>

      {/* Clear Floats */}
      <div className="tutorial-section">
        <h2 className="section-title">3️⃣ Clearing Floats (clear)</h2>
        <p>
          When using floats, sometimes the parent element collapses. The{" "}
          <code>clear</code> property is used to prevent text or elements from
          wrapping around floated elements.
        </p>

        <CodeCopyBlock
          code={`.clear-box {
  clear: both;
  background-color: #34d399;
  padding: 10px;
}`}
        />

        <div style={{ border: "2px dashed #34d399", padding: "10px" }}>
          <div
            style={{
              float: "left",
              width: "100px",
              height: "80px",
              backgroundColor: "#f87171",
              margin: "10px",
              borderRadius: "6px",
            }}
          ></div>
          <div
            style={{
              float: "right",
              width: "100px",
              height: "80px",
              backgroundColor: "#60a5fa",
              margin: "10px",
              borderRadius: "6px",
            }}
          ></div>
          <div
            style={{
              clear: "both",
              backgroundColor: "#34d399",
              padding: "10px",
              borderRadius: "6px",
            }}
          >
            This box is below the floats because of <code>clear: both;</code>
          </div>
        </div>
      </div>

      {/* Float with Image Example */}
      <div className="tutorial-section">
        <h2 className="section-title">4️⃣ Real-World Example (Image & Text)</h2>
        <p>
          Float is often used to wrap text around an image (e.g., in blogs or
          articles).
        </p>

        <CodeCopyBlock
          code={`img {
  float: left;
  margin: 10px;
  width: 120px;
  height: auto;
}`}
        />

        <div style={{ border: "2px dashed #f59e0b", padding: "10px" }}>
          <img
            src={img1}
            alt="Sample"
            style={{
              float: "left",
              margin: "10px",
              width: "120px",
              borderRadius: "6px",
            }}
          />
          <p>
            This is an example of text wrapping around a floated image. It is
            very common in newspapers, blogs, and content-heavy websites. The
            text continues to flow beside the image and creates a natural layout
            effect.
          </p>
        </div>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">🚀 Next Steps</h2>
        <p>
          Floats are powerful but limited for complex layouts. For modern
          designs, consider learning{" "}
          <a href="/css/flexbox" className="learn-more">
            Flexbox
          </a>{" "}
          and{" "}
          <a href="/css/grid" className="learn-more">
            CSS Grid
          </a>{" "}
          which provide more flexibility and control.
        </p>
      </div>
    </div>
  );
};

export default CSS_Float;
